export default __webpack_public_path__ + "static/stop3-f3dcdccc5aff50fd26853f264736e434.png";